var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 23.0572L22.19 20.2111L17 17.3649V23.0572ZM28.56 15.6288C28.69 16.0747 28.78 16.6724 28.84 17.4314C28.91 18.1903 28.94 18.8449 28.94 19.4142L29 20.2111C29 22.2888 28.84 23.8162 28.56 24.7934C28.31 25.6472 27.73 26.1975 26.83 26.4347C26.36 26.558 25.5 26.6434 24.18 26.7003C22.88 26.7667 21.69 26.7952 20.59 26.7952L19 26.8521C14.81 26.8521 12.2 26.7003 11.17 26.4347C10.27 26.1975 9.69 25.6472 9.44 24.7934C9.31 24.3475 9.22 23.7498 9.16 22.9908C9.09 22.2319 9.06 21.5772 9.06 21.008L9 20.2111C9 18.1334 9.16 16.606 9.44 15.6288C9.69 14.7749 10.27 14.2247 11.17 13.9875C11.64 13.8642 12.5 13.7788 13.82 13.7219C15.12 13.6555 16.31 13.627 17.41 13.627L19 13.5701C23.19 13.5701 25.8 13.7219 26.83 13.9875C27.73 14.2247 28.31 14.7749 28.56 15.6288Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterYoutube);
export default __webpack_public_path__ + "static/media/footer-youtube.58122eae.svg";
export { ForwardRef as ReactComponent };